import { GraphQLClient, Variables } from 'graphql-request';

import getConfig from '../../src/temp/config';

export const executeGQLQuery = async <T = unknown>(
  query: string,
  variables: Variables
): Promise<T> => {
  const config = getConfig();
  const client = new GraphQLClient(config.graphQLEndpoint, {
    fetch: fetch,
  });
  client.setHeader('sc_apikey', config.sitecoreApiKey);
  return await client.request(query, variables);
};
